<div class="modal-header">
  <h5 class="modal-title">ADD JSN TO PROJECT</h5>

  <span
    class="fa fa-close"
    aria-label="Close"
    (click)="activeModal.close()"
  ></span>
</div>
<div class="modal-body">
  <form [formGroup]="JSNForm">
    <div class="form-group d-flex flex-wrap">
      <div class="col-6 pl-0">
        <label>JSN NAME<span class="required-text">*</span></label>
        <input
          [ngClass]="{ 'disabled-control': true }"
          type="text"
          [value]="jsnName"
          class="form-control"
          disabled
          required
        />
      </div>
      <div class="col-6 pr-0">
        <label>JSN OTHER</label>
        <input
          [ngClass]="{ 'disabled-control': true }"
          type="text"
          [value]="jsnOther || ''"
          class="form-control"
          disabled
        />
      </div>
    </div>

    <div class="form-group">
      <label for="exampleFormControlSelect1"
        >DEPARTMENT<span class="required-text">*</span></label
      >
      <select
        formControlName="department"
        class="form-control"
        id="exampleFormControlSelect1"
        (change)="changeDepartment(JSNForm.get('department').value)"
      >
        <option value="">--- SELECT DEPARTMENT ---</option>
        <option [value]="'ALL'">ALL</option>
        <option *ngFor="let department of departments" [value]="department.id">
          {{ department.departmentname }}
        </option>
      </select>
    </div>
    <div class="form-group d-flex flex-wrap">
      <div class="col-6 pl-0">
        <label for="exampleFormControlSelect1">ROOM TYPE</label>
        <select
          formControlName="roomtype"
          class="form-control"
          id="exampleFormControlSelect1"
          (change)="getAllRooms(JSNForm.get('department').value)"
        >
          <option value="">--- SELECT ROOM TYPE ---</option>
          <option *ngFor="let type of roomTypes" [value]="type.roomtype">
            {{ type.roomtype }}
          </option>
        </select>
      </div>
      <div class="col-6">
        <label for="exampleFormControlSelect1">ROOM NAME</label>
        <select
          formControlName="roomname"
          class="form-control"
          id="exampleFormControlSelect1"
          (change)="getAllRooms(JSNForm.get('department').value)"
        >
          <option value="">--- SELECT ROOM NAME ---</option>
          <option *ngFor="let name of roomNames" [value]="name.roomname">
            {{ name?.roomname }}
          </option>
        </select>
      </div>
    </div>

    <div class="form-group add-jsn-room">
      <label>ROOM NUMBER<span class="required-text">*</span></label>

      <ng-select
        placeholder="--- SELECT ROOM NUMBER---"
        formControlName="room"
        [multiple]="true"
        [items]="rooms"
        [bindLabel]="'name'"
        [closeOnSelect]="false"
        class="custom-ng-select"
        [(ngModel)]="selectedItems"
      >
        <ng-template ng-header-tmp>
          <label>
            <input
              type="checkbox"
              (change)="toggleSelectAll($event)"
              [checked]="isAllSelected()"
            />
            Select All
          </label>
        </ng-template>
        <ng-template ng-optgroup-tmp let-item="item">
          <div class="custom-group">
            <strong> {{ item.name }}</strong>
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <label (change)="onCheckboxChange(item, $event)">
            <input type="checkbox" [checked]="isSelected(item)" />
            {{ item.name }}
          </label>
        </ng-template>
      </ng-select>
    </div>
    <div class="table-wrapper">
      <div class="content-wrapper">
        <table
          class="content-table w-100"
          [ngClass]="selectedItems.length ? 'd-block' : ''"
        >
          <tbody>
            <tr>
              <th width="20%">ROOM#</th>
              <th width="70%">ROOM NAME</th>
              <th width="10%">QTY.</th>
            </tr>
            <ng-container
              *ngIf="selectedItems && selectedItems.length > 0; else noRowData"
            >
              <tr
                style="font-family: 'BentonSans-Book'"
                *ngFor="let room of selectedItems; let i = index"
              >
                <td>
                  {{ room?.name }}
                </td>
                <td>
                  {{ room?.roomname }}
                </td>
                <td>
                  <input
                    type="number"
                    [ngClass]="'qty-' + i"
                    required
                    min="1"
                    value="1"
                  />
                </td>
              </tr>
            </ng-container>
            <ng-template #noRowData>
              <tr>
                <td class="text-center" colspan="12">No Data Found</td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!JSNForm.valid"
    (click)="saveJSNToRoom()"
  >
    Save
  </button>
  <button type="button" class="btn btn-default" (click)="activeModal.close()">
    Cancel
  </button>
</div>
